import FoodWatch from './FoodWatch';

export default FoodWatch;